import React from 'react';
import { ArrowRight, Check, ShieldCheck, Package } from 'lucide-react';
export function PricingSection() {
  return <section id="purchase" className="py-20 bg-gradient-to-b from-blue-900 via-blue-800 to-blue-900 relative overflow-hidden" data-id="element-54">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-55"></div>

      <div className="max-w-md mx-auto px-4 relative z-10" data-id="element-56">
        {/* Main Pricing Card */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-orange-400 relative" data-id="element-57">
          {/* Product Image */}
          <div className="bg-gradient-to-br from-blue-50 to-white p-8 border-b-4 border-orange-400" data-id="element-58">
            <div className="relative" data-id="element-59">
              <div className="absolute inset-0 bg-blue-200 blur-3xl opacity-30 rounded-lg" data-id="element-60"></div>
              <img src="https://cdn.magicpatterns.com/uploads/bagEEuW7kdK7tQb99ywwEx/Cover_SIC_360.png" alt="SIC 360 - Sistema Completo" className="relative z-10 w-full h-auto rounded-lg shadow-xl" data-id="element-61" />
            </div>
          </div>

          {/* Pricing */}
          <div className="px-8 pt-8 pb-6 text-center border-b border-slate-100" data-id="element-62">
            <p className="text-slate-400 uppercase tracking-wider text-sm font-bold mb-2" data-id="element-63">
              Precio Final
            </p>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-64">
              <span className="text-slate-400 text-2xl font-bold line-through" data-id="element-65">
                $49.990
              </span>
              <span className="text-blue-900 text-5xl md:text-6xl font-black" data-id="element-66">
                $19.990
              </span>
            </div>
          </div>

          {/* Benefits List */}
          <div className="px-8 py-6 space-y-4" data-id="element-67">
            {/* Benefit 1 */}
            <div className="bg-green-50 rounded-xl p-4 border border-green-100" data-id="element-68">
              <div className="flex items-start gap-3" data-id="element-69">
                <div className="bg-green-500 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-70">
                  <Check className="w-4 h-4 text-white" data-id="element-71" />
                </div>
                <div data-id="element-72">
                  <h3 className="font-bold text-slate-900 mb-1" data-id="element-73">
                    Sistema Completo SIC 360
                  </h3>
                  <p className="text-sm text-slate-600" data-id="element-74">
                    Clases estructuradas para todo el año lectivo con ejemplos
                    argentinos actuales
                  </p>
                </div>
              </div>
            </div>

            {/* Benefit 2 */}
            <div className="bg-orange-50 rounded-xl p-4 border border-orange-100" data-id="element-75">
              <div className="flex items-start gap-3" data-id="element-76">
                <div className="bg-green-500 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-77">
                  <Check className="w-4 h-4 text-white" data-id="element-78" />
                </div>
                <div data-id="element-79">
                  <h3 className="font-bold text-slate-900 mb-1" data-id="element-80">
                    4 Bonos Exclusivos (Gratis por hoy)
                  </h3>
                  <p className="text-sm text-slate-600" data-id="element-81">
                    Banco de ejemplos, clases express, evaluaciones listas y
                    mapa anual de contenidos
                  </p>
                </div>
              </div>
            </div>

            {/* Benefit 3 */}
            <div className="bg-blue-50 rounded-xl p-4 border border-blue-100" data-id="element-82">
              <div className="flex items-start gap-3" data-id="element-83">
                <div className="bg-green-500 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-84">
                  <Check className="w-4 h-4 text-white" data-id="element-85" />
                </div>
                <div data-id="element-86">
                  <h3 className="font-bold text-slate-900 mb-1" data-id="element-87">
                    Acceso Inmediato y Vitalicio
                  </h3>
                  <p className="text-sm text-slate-600" data-id="element-88">
                    Descargá todo el material al instante y accedé cuando lo
                    necesites, sin vencimiento
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="px-8 pb-8" data-id="element-89">
            <a href="https://checkout.rincondigital.shop/cart/52917830517011:1" className="block w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-black py-5 px-6 rounded-2xl shadow-lg transform transition hover:-translate-y-1 text-center text-lg group relative overflow-hidden" data-id="element-90">
              <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-91">
                ACCEDÉ AHORA Y EMPEZÁ A ENSEÑAR
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-92" />
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-orange-700 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-93"></div>
            </a>

            {/* Trust Badges */}
            <div className="flex items-center justify-center gap-6 mt-6 text-slate-500 text-xs" data-id="element-94">
              <div className="flex items-center gap-1" data-id="element-95">
                <ShieldCheck className="w-4 h-4" data-id="element-96" />
                <span data-id="element-97">Compra Segura</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-98">
                <Package className="w-4 h-4" data-id="element-99" />
                <span data-id="element-100">Material Digital</span>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Trust Message */}
        <div className="mt-8 text-center" data-id="element-101">
          <p className="text-white text-lg font-medium" data-id="element-102">
            Descubrí cómo funciona SIC 360 y volvé a entrar al aula con
            confianza.
          </p>
        </div>
      </div>
    </section>;
}